import NetworkApi from '../libs/network/d'
import Formatter from '../libs/base/formatter'
const timeFormatter = Formatter('History')
export interface IUsr {
    userId: number
    name: string
    phoneNumber: string
}
export interface ITools {
    toolId?: number
    toolName?: string
    avatar?: string
    type?: string
    toolNumber?: number;
    available?: number;
    rented?: number;
    lost?: number;
    inoperative?: number;
}

export interface IHistory {
    rentId: number
    userId: number
    name: string
    toolId: number
    toolName: string
    avatar: string
    rentedNumber: number
    rentTime: string
    returnTime: string
    rentImg: string
    returnImg: string
    state: string
}

export interface Page<T> {
    pages: number
    records: T
    current: number
    size: number

}

class AdminNetwork {
    private network: NetworkApi

    constructor(network: NetworkApi) {
        this.network = network
    }


    public list = (params: { page: number; pageSize: number }) => {
        const data = this.network.postItem<IUsr[]>('admin/user/list', params)
        return data.loading()
    }

    public update = (params: { userId: number; phoneNumber?: string; name?: string; password?: string }) => {
        Object.keys(params).forEach(key => {
            if (params[key] === undefined) {
                delete params[key];
            }
        });
        const data = this.network.postItem<string>('admin/user/update', params)
        return data.loading()
    }

    public delete = (uid: string) => {
        const res = this.network.postItem<string>(`admin/user/delete/${uid}`)
        return res.loading()
    }

    public add = (user: {
        phoneNumber: string,
        name: string,
        password: string,
        admin: number
    }) => {
        const res = this.network.postItem<string>(`admin/user/add`, user)
        return res.loading()
    }

    public tools = (params: { page: number; pageSize: number }) => {
        const res = this.network.postItem<Page<ITools[]>>(`admin/tool/list`, params).next(res => res.records)
        return res.loading()
    }

    public updateTools = (params: ITools) => {
        const res = this.network.postItem<string>(`admin/tool/update`, params)
        return res.loading()
    }

    public deleteTools = (toolsId: string) => {
        const res = this.network.postItem<string>(`admin/tool/delete/${toolsId}`)
        return res.loading()
    }

    public addTools = (tools: ITools) => {
        Object.keys(tools).forEach(key => {
            if (key === 'toolId') {
                delete tools[key];
            }
        });
        const res = this.network.postItem<string>(`admin/tool/add`, tools)
        return res.loading()
    }

    public history = (params: { page: number; pageSize: number }) => {
        const res = this.network.postItem<Page<IHistory[]>>(`admin/history/list`, params).next(res => {
            res.records = res.records.map(item => {
                item.rentTime = timeFormatter.timeStamp2String(item.rentTime)
                item.returnTime = timeFormatter.timeStamp2String(item.returnTime)
                item.state = (Number(item.state) == 1) ? '已归还' : '未归还'
                return item
            })
        })
        return res.loading()
    }
}
const Admin = (network: NetworkApi) => new AdminNetwork(network);
export default Admin
